import pubsub from './pubsub.js';

let cacheSt

const checkScroll = function() {
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if(st != cacheSt) {
        cacheSt = st
        pubsub.emit('page.scroll', st)
    }
}

const init = function() {

    window.addEventListener('scroll', function() {
        requestAnimationFrame(checkScroll)
    })

}

export default init;